import { object, number, string, InferType, boolean } from "yup";

export enum PlatformType {
    AGENCY = "agency",
    PLATFORM = "platform",
    DIRECT = "direct",
}

export const PlatformSchema = object({
    id: number().required(),
    name: string().required("error.platform.name.required"),
    type: string().required("error.platform.type.required").oneOf(Object.values(PlatformType)),
    comment: string().optional().max(500, "error.platform.comment.max"),
    login: string().nullable(),
    password: string().nullable(),
    manager: object({
        id: number().required(),
        name: string().required(),
    }),
    active: boolean().default(true),
});

export const PlatformGridSchema = object({
    id: number().required(),
    active: boolean().default(true),
    name: string().required("error.platform.name.required"),
    login: string().nullable(),
    password: string().nullable(),
    comment: string().optional().max(500, "error.platform.comment.max"),
    manager: string().required("error.platform.manager.required"),
});

export const PlatformDTOSchema = PlatformSchema.omit(["id", "manager", "active"]).concat(
    object({
        managerId: number().required("error.platform.managerId.required"),
    })
);
export type PlatformDTO = InferType<typeof PlatformDTOSchema>;

export type Platform = InferType<typeof PlatformSchema>;

export type PlatformGrid = InferType<typeof PlatformGridSchema>;
